import { Component, OnInit } from '@angular/core';
import { OverlayEventDetail } from '@ionic/core/components';
import { CurrencyPipe } from '@angular/common';
import { Order } from 'src/app/shared/order.model';
import { Client } from 'src/app/shared/client.model';
import { Product } from 'src/app/shared/product.model';
import { ToastController, LoadingController } from '@ionic/angular';
import { AuthService } from 'src/app/service/auth.service';
import { OrderResponse } from 'src/app/shared/orderResponse.model';
import { OrderDetailResponse } from 'src/app/shared/orderDetailResponse.model';
import { FilterDate } from 'src/app/shared/filterDate.model';
import { SendMessage } from 'src/app/shared/sendMessage.model';
import { environment } from "src/environments/environment";
import { SendMessageResponse } from 'src/app/shared/sendMessageResponse.model';
import { Constant } from '../../shared/model/Constant';

import * as XLSX from 'xlsx';
import { OrderService } from 'src/app/service/order.service';
import { ReportOrderResponse } from 'src/app/shared/reportOrderResponse.model';

@Component({
  selector: 'app-purchase-order',
  templateUrl: './list-orders.page.html',
  styleUrls: ['./list-orders.page.scss'],
})
export class ListOrdersPage implements OnInit {

  fechaIni: Date;
  iDate: Date;

  fechaFin: Date;
  fDate: Date;
  orders: OrderResponse[];
  ordersFiltered: OrderResponse[];
  client: Client;
  product: Product;
  order: Order;
  loading: any;
  pageSizeNumber: string;
  userId: string;
  filterDate: FilterDate;
  showDetailOrder: boolean = false;
  showDeleteOrder: boolean = false;
  showEditOrder: boolean = false;
  detailSelect: OrderDetailResponse[];
  totalAmountProduct: number;
  totalDiscount: number;
  orderSelected: OrderResponse;
  reasonDeleteOrder: string;
  auxamount: number;
  amount: string;
  sendCelular: string;
  sendwhatsapp: string;
  typeSend: string;
  orderSendSelect: OrderResponse;
  EXCEL_TYPE: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION: string = '.xlsx';
  reportOrderResponse: ReportOrderResponse[];


  constructor(
    private currencyPipe: CurrencyPipe,
    private authService: AuthService,
    private orderService: OrderService,
    public loadingController: LoadingController,
    public toastController: ToastController
  ) {
    this.userId = localStorage.getItem(Constant.userId);
  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
  }

  onChangePage(event: any) {
    this.ordersFiltered = event;
  }

  //************************************ MANIPULACION MODALES***************************************************************************
  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 1000,
      position: 'top',
      mode: 'ios',  
      color: 'primary'
    });
    toast.present();
  }

  onWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    
  }


  deleteModalOrder(orderId: OrderResponse) {
    this.showDeleteOrder = true;
    this.orderSelected = orderId;
    this.order = new Order();
    this.order.reason = this.reasonDeleteOrder;
    this.order.idOrder = orderId.idOrder;
    this.order.amount = 0;
    this.order.idstatusorder = 3;
  }

  editModalOrder(orderId: OrderResponse) {
    if (orderId.idstatusorder !== 2) {
      this.presentToast('Para poder editar el estado de la orden debe ser rechazado.');
      return;
    }
    this.orderSelected = orderId;
    this.order = new Order();
    this.order.idOrder = orderId.idOrder;
    this.order.amount = this.orderSelected.amount;
    this.order.idstatusorder = 1;
    this.showEditOrder = true;
    this.amount = this.currencyPipe.transform(this.order.amount, 'COP', 'symbol-narrow', '1.0-0');
  }

  async showModalOrden(orderSelect: OrderResponse) {
    this.orderSendSelect = orderSelect;
    var detailSelect = this.orderSendSelect.orderDetail;
    this.totalAmountProduct = 0;
    this.totalDiscount = 0;

    this.sendCelular = orderSelect.client.celular ? String(orderSelect.client.celular).substring(0, 1) + '****' + String(orderSelect.client.celular).substring(5, String(orderSelect.client.celular).length) : null;
    this.sendwhatsapp = orderSelect.client.whatsapp ? String(orderSelect.client.whatsapp).substring(0, 1) + '****' + String(orderSelect.client.whatsapp).substring(5, String(orderSelect.client.whatsapp).length) : null;
    await detailSelect.forEach(detail => {
      this.totalAmountProduct = this.totalAmountProduct + detail.value * detail.quantity;
      this.totalDiscount = this.totalDiscount + detail.discount;
    });
    this.totalAmountProduct = this.totalAmountProduct - this.totalDiscount;
    this.showDetailOrder = true;
    this.detailSelect = detailSelect;
  }

  onWillDismissProduct(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    
  }

  closeModal() {
    this.showDetailOrder = false;
    this.showDeleteOrder = false;
    this.showEditOrder = false;
    this.typeSend = null;
  }


  //************************************ EVENTOS DE APLICACION ***************************************************************************
  async searchOrdersClient() {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 100000
    });
    await loading.present();

    if (!this.iDate || !this.fDate) {
      this.presentToast('Es necesario indicar las fechas a consultar.');
      loading.dismiss();
      return;
    }

    this.filterDate = new FilterDate(
      this.iDate.toString().split('T')[0] + ' 00:00:00',
      this.fDate.toString().split('T')[0] + ' 23:59:59'
    );

    this.orderService.getOrdersByUserId(this.userId, this.filterDate).subscribe((res: OrderResponse[]) => {
      this.orders = res;
      this.ordersFiltered = this.orders;
      this.orderService.reportOrder(this.userId, this.filterDate).subscribe((resp: ReportOrderResponse[]) => {
        this.reportOrderResponse = resp;
        
      }, error => {
        console.warn('Error no se encontro informacion del reporte ', error);
      });
      loading.dismiss();
    }, error => {
      console.warn('Error consulta ordenes ', error);
      this.presentToast('No se encuentra ordenes para este comercio.');
      loading.dismiss();
    });
  }

  serachOrders(event) {
    const text = event.target.value;
    this.ordersFiltered = this.orders;
    if (text) {
      this.ordersFiltered = this.orders.filter((order: OrderResponse) => {

        return (String(order.idOrder).indexOf(text) > -1
          || String(order.client.document).indexOf(text) > -1
          || order.client.firstLastName.indexOf(text) > -1
          || order.client.firstName.indexOf(text) > -1);
      });
    }
  }

  async deleteOrder() {
    await this.loading.present();
    this.order.reason = this.reasonDeleteOrder;
    this.orderService.updateOrder(this.order).subscribe((res: OrderResponse) => {
      if (res.idOrder) {
        this.presentToast('Orden Cancelada exitosamente .....');
        this.showDeleteOrder = false;
        this.reasonDeleteOrder = null;
        let element: HTMLElement = document.getElementById('searchButton') as HTMLElement;
        element.click();
      }
    }, error => {
      console.warn('Error cancelando la orden ', error);
      this.presentToast('No se logra cancelar la orden seleccionada.');
    });
  }

  async editAmountOrder() {
    await this.loading.present();
    this.order.amount = this.auxamount;
    this.orderService.updateOrder(this.order).subscribe((res: OrderResponse) => {
      if (res.idOrder) {
        this.presentToast('Orden Editada exitosamente .....');
        this.showEditOrder = false;
        setTimeout(() => {
          window.location.href = '/listOrders';
        }, 1000);

      }
    }, error => {
      console.warn('Error Editando la orden ', error);
      this.presentToast('No se logra editar la orden seleccionada .');
    });
  }

  //************************************ VALIDADORES***************************************************************************
  validateOnlyAmount() {
    try {
      if (this.amount) {
        let amountNumber = String(this.amount).split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxamount = Number(amountNumber.split(".").join(''));
        this.amount = this.currencyPipe.transform(this.auxamount, 'COP', 'symbol-narrow', '1.0-0');
      }
    } catch (error) {
      console.log("Error en valor: " + error);
    }
  }

  validateOnlyNumbers() {

    if (this.pageSizeNumber) {
      this.pageSizeNumber = String(this.pageSizeNumber).replace(/\D/g, '');
    }

  }

  sendOrderAndFinish() {
    var sendMessage = new SendMessage();
    sendMessage.to = "+57" + this.orderSendSelect.client.celular;
    sendMessage.message = "Hola!! estimado cliente para continuar con el proceso de compra este es el link de pago "
      + environment.web.orderUri + this.orderSendSelect.idOrder + " ";
    switch (this.typeSend) {
      case 'SMS': {
        this.authService.sendSMS(sendMessage).subscribe((res: SendMessageResponse) => {
          if (res.status) {
            this.presentToast('Mensaje Enviado SMS.');
            this.closeModal();
          }
        }, error => {
          console.warn('Error enviando mensaje ', error);
          this.presentToast('Error enviando mensaje.');
        });
        break;
      };
      case 'WSP': {
        this.authService.sendWathsapp(sendMessage).subscribe((res: SendMessageResponse) => {
          if (res.status) {
            this.presentToast('Mensaje Enviado WSP.');
            this.closeModal();
          }
        }, error => {
          console.warn('Error enviando mensaje ', error);
          this.presentToast('Error enviando mensaje.');
        });
        break;
      };
      default: {
        this.authService.sendSMS(sendMessage).subscribe((res: SendMessageResponse) => {
          if (res.status) {
            this.presentToast('Mensaje Enviado SMS.');
            this.closeModal();
          }
        }, error => {
          console.warn('Error enviando mensaje ', error);
          this.presentToast('Error enviando mensaje.');
        });
        break;
      }

    }
  }

  checkTypeSend(tipo: string) {
    console.warn('tipo selected.', tipo);
    this.typeSend = tipo;
  }

  export() {
    const worksheet = XLSX.utils.table_to_sheet(document.getElementById('table'));
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'orders');
    XLSX.writeFile(workbook, 'report-orders-client' + this.EXCEL_EXTENSION);
  }

}
